import './blog-post.scss';

export default () => {

};
